
import { Component, Prop, Vue } from "vue-property-decorator";
import ProduceNavVue from "@/components/product/ProductNav.vue";
import { RouterHelper } from "@/router/routerHelper";

@Component({
  components: {
    "product-nav": ProduceNavVue,
  },
})
export default class X51Vue extends Vue {
  /** 各段高度直接取切图的实际高度，加起来 = 设计稿内容总高 9740（效果图总高 9952，底部 212px 是空白画布） */
  bannerH: number = 750;
  introH: number = 562;

  /** 首屏 banner，切图 1920×750 */
  banner: string = require("@/assets/img/prod/x51/1.jpg");

  /** 产品简介文字层，切图 1920×562（整段透明底） */
  intro: string = require("@/assets/img/prod/x51/2-text.png");

  /** 特性段，背景图 + 文字层同高叠加；第 9、10 段（产品清单 / 产品规格）整段自带文字，没有单独文字层 */
  sections: Array<any> = [
    {
      id: 3,
      h: 1080,
      bg: require("@/assets/img/prod/x51/3.jpg"),
      txt: require("@/assets/img/prod/x51/3-text.png"),
    },
    {
      id: 4,
      h: 1079,
      bg: require("@/assets/img/prod/x51/4.jpg"),
      txt: require("@/assets/img/prod/x51/4-text.png"),
    },
    {
      id: 5,
      h: 1082,
      bg: require("@/assets/img/prod/x51/5.jpg"),
      txt: require("@/assets/img/prod/x51/5-text.png"),
    },
    {
      id: 6,
      h: 1109,
      bg: require("@/assets/img/prod/x51/6.jpg"),
      txt: require("@/assets/img/prod/x51/6-text.png"),
    },
    {
      id: 7,
      h: 1203,
      bg: require("@/assets/img/prod/x51/7.jpg"),
      txt: require("@/assets/img/prod/x51/7-text.png"),
    },
    {
      id: 8,
      h: 1082,
      bg: require("@/assets/img/prod/x51/8.jpg"),
      txt: require("@/assets/img/prod/x51/8-text.png"),
    },
    {
      id: 9,
      h: 1082,
      bg: require("@/assets/img/prod/x51/9.jpg"),
      txt: require("@/assets/img/prod/x51/9-text.png"),
    },
    {
      id: 9,
      h: 1080,
      bg: require("@/assets/img/prod/x51/10.jpg"),
      txt: "",
    },
    {
      id: 10,
      h: 713,
      bg: require("@/assets/img/prod/x51/11.jpg"),
      txt: "",
    },
  ];

  tabList: Array<any> = [];

  mounted() {
    new (<any>window).WOW().init();

    RouterHelper.getProdRouterConfig("x51", (data: Array<any>) => {
      this.tabList = data;
    });
  }
}
